import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BookingRequestsView = lazy(() => import('./components/BookingRequestsView'));

/**
 * The Booking Requests routes.
 */
const bookingRequestsRoutes: FuseRouteItemType[] = [
	{
		path: 'booking-requests',
		children: [
			{
				index: true,
				element: <BookingRequestsView />
			},
			{
				path: ':requestId',
				element: <BookingRequestsView />
			}
		]
	}
];

export default bookingRequestsRoutes;
